// Utility function for .filter(Boolean)
// https://stackoverflow.com/questions/47632622/typescript-and-filter-boolean
// https://github.com/microsoft/TypeScript/issues/16655
export const isTruthy = Boolean as any as <T>(
  x: T | false | null | undefined | '' | 0
) => x is T;

export type Excluded<T extends K, K> = Omit<T, keyof K>;

export type Extend<A, B> = Omit<A, keyof B> & B;

export enum MouseButton {
  PRIMARY = 0,
  SECONDARY = 2,
}

export type CidArgs = {
  readonly cid: string;
};

/**
 * Marks all properties of T as nullable.
 * They are still required, unlike the Partial<T> utility type.
 */
export type Nullable<T> = { [K in keyof T]: T[K] | null };

/**
 * This type requires you to use at least one of the optional properties of
 * a type. For example:
 *
 * interface ExampleType {
 *   components?: Component[];
 *   references?: Reference[];
 * }
 *
 * RequireAtLeastOnce<ExampleType, 'references' | 'components'>
 */
export type RequireAtLeastOne<T, Keys extends keyof T = keyof T> = Pick<
  T,
  Exclude<keyof T, Keys>
> &
  {
    [K in Keys]-?: Required<Pick<T, K>> & Partial<Pick<T, Exclude<Keys, K>>>;
  }[Keys];

export type NonEmptyArray<T> = [T, ...T[]];
